$(document).ready(function () {
    $(".btn-expand, .btn-collapse").on("click", function () {
        const block = $("#" + $(this).data("target"));

        block.toggleClass("expanded");
        block.find(".short-content").slideToggle(300);
        block.find(".full-content").slideToggle(300);
        block.find(".btn-expand").toggle();
        block.find(".btn-collapse").toggle();
    });
});
